import { LOCALISATION_CONFIGURATION, LOCALISATION_ADMIN } from '@/configuration/general/paramConf';

export const SET_TARIFS_UNITAIRE = 'SET_TARIFS_UNITAIRE';
export const SET_TARIFS_LIBRE = 'SET_TARIFS_LIBRE';
export const SET_PARAMETRE = 'SET_PARAMETRE';
export const RESET_PARAMETRES = 'RESET_PARAMETRES';
export const RESET_PARAMETRES_INTERNE = 'RESET_PARAMETRES_INTERNE';
export const SET_PARAMETRE_INTERNE = 'SET_PARAMETRE_INTERNE';

/* Type des parametres gerés par le store */
export const PARAMETRES_KEYS = {
  delaiReglement: 'commun/DelaiReglement',
  modeReglement: 'commun/ModeReglement',
  domiciliationBancaire: 'commun/DomiciliationBancaire',
  format: 'gescom/Format',
  typeReseau: 'gescom/TypeReseau',
  secteurActivite: 'commun/SecteurActivite',
  civilite: 'commun/Civilite',
  dispositifSupport: 'patri/DispositifSupport',
  dispositifType: 'patri/DispositifType',
  materielLocalisation: 'patri/MaterielLocalisation',
  materielAngleVision: 'patri/MaterielAngleVision',
  materielFormat: 'patri/MaterielFormat',
  materielType: 'patri/MaterielType',
  faceMotifNonCom: 'commun/FaceMotifNonCom',
  utilisateur: 'commun/Utilisateur',
  exercice: 'commun/ExerciceComptable',
  commentaire: 'commun/Commentaire',
  contratNature: 'patri/ContratNature',
  contratSignataire: 'patri/ContratSignataire',
  parametrageEdition: 'commun/ParametrageEdition',
  motifBlocage: 'commun/MotifBlocage',
  typePointVente: 'commun/TypePointVente',
  profilTiers: 'commun/ProfilTiers',
  regimeTva: 'commun/RegimeTva',
  compteAnalytique: 'gescom/CompteAnalytique',
  categorieGroupeProduitDeductible: 'gescom/CategorieGroupeProduitDeductible',
  remise: 'commun/Remise',
  accessoire: 'commun/Accessoire',
  typeOt: 'gescom/TypeOt',
  couleurEncart: 'gescom/CouleurEncart',
  typeProduit: 'commun/TypeProduit',
  periodicite: 'commun/Periodicite',
  regleFacturation: 'gescom/RegleFacturation',
  emplacementPresse: 'gescom/EmplacementPresse',
  surface: 'gescom/Surface',
  modeDistribution: 'gescom/ModeDistribution',
  typeEvenementSponsoring: 'gescom/TypeEvenementSponsoring',
  typeContact: 'commun/TypeContact',
  typeEvenement: 'gescom/TypeEvenementPM',
  motifAnnulationReglement: 'gescom/MotifAnnulationReglement',
  etatSuiviAdministratif: 'commun/EtatSuiviAdministratif',
  marque: 'commun/Marque',
  tag: 'commun/Tag',
  nomenclatureType: 'commun/NomenclatureType',
  secteur: 'gescom/Secteur',
  pays: 'commun/Pays',
  fonctionContact: 'commun/FonctionContact',
  natureSupportAffiche: 'commun/NatureSupportAffiche',
  competenceFournisseur: 'commun/CompetenceFournisseur',
  formatAffiche: 'gescom/FormatAffiche',
};

export const PARAMETRES_INTERNE_KEYS = {
  ibizaBaseUrl: {
    key: 'IbizaBaseUrl',
    type: String,
    traduction: 'paramInterne.ibizaBaseUrl',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  ibizaPartnerId: {
    key: 'IbizaPartnerId',
    type: String,
    traduction: 'paramInterne.ibizaPartnerId',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  portailClientBaseUrl: {
    key: 'PortailClientBaseUrl',
    type: String,
    traduction: 'paramInterne.portailClientBaseUrl',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  autoriserAuthentificationAffixe1: {
    key: 'AutoriserAuthentificationAffixe1',
    type: String,
    traduction: 'paramInterne.autoriserAuthentificationAffixe1',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  listeAlpha2CodePaysLimiteAutocompleteGoogle: {
    key: 'ListeAlpha2CodePaysLimiteAutocompleteGoogle',
    type: String,
    traduction: 'paramInterne.listeAlpha2CodePaysLimiteAutocompleteGoogle',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  filtrerProduitParSociete: {
    key: 'FiltrerProduitParSociete',
    type: Boolean,
    traduction: 'paramInterne.filtrerProduitParSociete',
    localisation: LOCALISATION_CONFIGURATION,
  },
  filtrerProduitParAgence: {
    key: 'FiltrerProduitParAgence',
    type: Boolean,
    traduction: 'paramInterne.filtrerProduitParAgence',
    localisation: LOCALISATION_CONFIGURATION,
  },
  googleMapApiKey: {
    key: 'GoogleMapApiKey',
    type: String,
    traduction: 'paramInterne.googleMapApiKey',
    localisation: LOCALISATION_CONFIGURATION,
  },
  mentionMandataire: {
    key: 'MentionMandataire',
    type: Boolean,
    traduction: 'paramInterne.mentionMandataire',
    localisation: LOCALISATION_CONFIGURATION,
  },
  blocageFiltreCommercial: {
    key: 'BlocageFiltreCommercial',
    type: Boolean,
    traduction: 'paramInterne.blocageFiltreCommercial',
    localisation: LOCALISATION_CONFIGURATION,
  },
  filtrerAutoParUtilisateur: {
    key: 'FiltrerAutoParUtilisateur',
    type: Boolean,
    traduction: 'paramInterne.filtrerAutoParUtilisateur',
    localisation: LOCALISATION_CONFIGURATION,
  },
  checkCompteComptable: {
    key: 'CheckCompteComptable',
    type: Boolean,
    traduction: 'paramInterne.checkCompteComptable',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  nombreTraitesParPage: {
    key: 'NombreTraitesParPage',
    type: 'number',
    traduction: 'paramInterne.nombreTraitesParPage',
    localisation: LOCALISATION_CONFIGURATION,
  },
  affichageCommercialDcf: {
    key: 'AffichageCommercialDcf',
    type: Boolean,
    traduction: 'paramInterne.affichageCommercialDcf',
    localisation: LOCALISATION_CONFIGURATION,
  },
  periodeTotalCalculTlpeAuto: {
    key: 'PeriodeTotalCalculTlpeAuto',
    type: Boolean,
    traduction: 'paramInterne.periodeTotalCalculTlpeAuto',
    localisation: LOCALISATION_CONFIGURATION,
  },
  nbAnneeRenouvellementContrat: {
    key: 'NbAnneeRenouvellementContrat',
    type: 'number',
    traduction: 'paramInterne.nbAnneeRenouvellementContrat',
    localisation: LOCALISATION_CONFIGURATION,
  },
  masquerCgvSurFacture: {
    key: 'MasquerCGVSurFacture',
    type: Boolean,
    traduction: 'paramInterne.masquerCgvSurFacture',
    localisation: LOCALISATION_CONFIGURATION,
  },
  produitAdressePersonaliseeDefaut: {
    key: 'ProduitAdressePersonaliseeDefaut',
    type: Boolean,
    traduction: 'paramInterne.produitAdressePersonaliseeDefaut',
    localisation: LOCALISATION_CONFIGURATION,
  },
  afficherLogistiqueTechnique: {
    key: 'AfficherLogistiqueTechnique',
    type: Boolean,
    traduction: 'paramInterne.afficherLogistiqueTechnique',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  activationYield: {
    key: 'ActivationYield',
    type: Boolean,
    traduction: 'paramInterne.activationYield',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  afficherProjetDossierLogistiqueTechnique: {
    key: 'AfficherProjetDossierLogistiqueTechnique',
    type: Boolean,
    traduction: 'paramInterne.afficherProjetDossierLogistiqueTechnique',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  controleYield: {
    key: 'ControleYield',
    type: Boolean,
    traduction: 'paramInterne.controleYield',
    localisation: LOCALISATION_CONFIGURATION,
  },
  modulePresse: {
    key: 'ModulePresse',
    type: Boolean,
    traduction: 'paramInterne.modulePresse',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  produitReseauMairie: {
    key: 'ModuleReseauMairie',
    type: Boolean,
    traduction: 'paramInterne.produit.ReseauMairie',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  produitSalon: {
    key: 'ProduitSalon',
    type: Boolean,
    traduction: 'paramInterne.produit.salon',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  produitSponsoring: {
    key: 'ProduitSponsoring',
    type: Boolean,
    traduction: 'paramInterne.produit.sponsoring',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  produitAutre: {
    key: 'ProduitAutre',
    type: Boolean,
    traduction: 'paramInterne.produit.autre',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  delaiTaciteParDefaut: {
    key: 'NombreMoisPreavisParDefaut',
    type: 'number',
    traduction: 'paramInterne.nombreMoisPreavisParDefaut',
    localisation: LOCALISATION_CONFIGURATION,
  },
  editionOtWithReseau: {
    key: 'EditionOtWithReseau',
    type: Boolean,
    traduction: 'paramInterne.editionOtWithReseau',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  acompteAvecTva: {
    key: 'AcompteAvecTva',
    type: Boolean,
    traduction: 'paramInterne.acompteAvecTva',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  nbreMoisDefaultFiltreJournal: {
    key: 'NbreMoisDefaultFiltreJournal',
    type: Boolean,
    traduction: 'paramInterne.NbreMoisDefaultFiltreJournal',
    localisation: LOCALISATION_CONFIGURATION,
  },
  logoParAgence: {
    key: 'LogoParAgence',
    type: Boolean,
    traduction: 'paramInterne.logoParAgence',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  majAutoAdresseCommercialeAvecEnAllantVers: {
    key: 'MajAutoAdresseCommercialeAvecEnAllantVers',
    type: Boolean,
    traduction: 'paramInterne.majAutoAdresseCommercialeAvecEnAllantVers',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  blocSignatureAgence: {
    key: 'BlocSignatureAgence',
    type: String,
    traduction: 'paramInterne.blocSignatureAgence',
    localisation: LOCALISATION_CONFIGURATION,
  },
  prelevementSepa: {
    key: 'PrelevementSepa',
    type: Boolean,
    traduction: 'paramInterne.prelevementSepa',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  retrocessionAlfa: {
    key: 'RetrocessionAlfa',
    type: Boolean,
    traduction: 'paramInterne.retrocessionAlfa',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  emailContactPayeurEditionFacture: {
    key: 'EmailContactPayeurEditionFacture',
    type: Boolean,
    traduction: 'paramInterne.emailContactPayeurEditionFacture',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  priseEnCompteMontageLogistique: {
    key: 'PriseEnCompteMontageLogistique',
    type: Boolean,
    traduction: 'paramInterne.priseEnCompteMontageLogistique',
    localisation: LOCALISATION_CONFIGURATION,
  },
  recopierTousLesPayeursSurFacture: {
    key: 'RecopierTousLesPayeursSurFacture',
    type: Boolean,
    traduction: 'paramInterne.recopierTousLesPayeursSurFacture',
    localisation: LOCALISATION_CONFIGURATION,
  },
  afficherRegleFacturationEditionFacture: {
    key: 'AfficherRegleFacturationEditionFacture',
    type: Boolean,
    traduction: 'paramInterne.afficherRegleFacturationEditionFacture',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  moduleFactor: {
    key: 'ModuleFactor',
    type: Boolean,
    traduction: 'paramInterne.moduleFactor',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  remiseComptabilisee: {
    key: 'RemiseComptabilisee',
    type: Boolean,
    traduction: 'paramInterne.remiseComptabilisee',
    localisation: LOCALISATION_CONFIGURATION,
  },
  affixeMobile: {
    key: 'AffixeMobile',
    type: Boolean,
    traduction: 'paramInterne.affixeMobile',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleMobileOT: {
    key: 'ModuleMobileOT',
    type: Boolean,
    traduction: 'paramInterne.moduleMobileOT',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  affixeMobileOTAffichage: {
    key: 'AffixeMobileOTAffichage',
    type: Boolean,
    traduction: 'paramInterne.affixeMobileOTAffichage',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  ajouterBATdansMail: {
    key: 'AjouterBATDansMail',
    type: Boolean,
    traduction: 'paramInterne.ajouterBATdansMail',
    localisation: LOCALISATION_CONFIGURATION,
  },
  calculCaFace: {
    key: 'CalculCaFace',
    type: Boolean,
    traduction: 'paramInterne.calculCaFace',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  signatureElectronique: {
    key: 'SignatureElectronique',
    type: Boolean,
    traduction: 'paramInterne.signatureElectronique',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  emailAutorizeFrom: {
    key: 'EmailAutorizeFrom',
    type: Boolean,
    traduction: 'paramInterne.emailAutorizeFrom',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  moduleEmplacementClient: {
    key: 'ModuleEmplacementClient',
    type: Boolean,
    traduction: 'paramInterne.moduleEmplacementClient',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  desactivationControleSignatureSurVenteDevis: {
    key: 'DesactivationControleSignatureSurVenteDevis',
    type: Boolean,
    traduction: 'paramInterne.desactivationControleSignatureSurVenteDevis',
    localisation: LOCALISATION_CONFIGURATION,
  },
  modulePortailBailleur: {
    key: 'PortailBailleur',
    type: Boolean,
    traduction: 'paramInterne.modulePortailBailleur',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  modulePortailClient: {
    key: 'PortailClient',
    type: Boolean,
    traduction: 'paramInterne.modulePortailClient',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleMarche: {
    key: 'ModuleMarche',
    type: Boolean,
    traduction: 'paramInterne.moduleMarche',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  modulePlanMedia: {
    key: 'ModulePlanMedia',
    type: Boolean,
    traduction: 'paramInterne.modulePlanMedia',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleFournisseurSupport: {
    key: 'ModuleFournisseurSupport',
    type: Boolean,
    traduction: 'paramInterne.moduleFournisseurSupport',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleIndexationCommande: {
    key: 'ModuleIndexationCommande',
    type: Boolean,
    traduction: 'paramInterne.moduleIndexationCommande',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleStockTiers: {
    key: 'ModuleStockTiers',
    type: Boolean,
    traduction: 'paramInterne.moduleStockTiers',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  produitPresse: {
    key: 'ProduitPresse',
    type: Boolean,
    traduction: 'paramInterne.produit.presse',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  moduleProduitReseauNumerique: {
    key: 'ModuleProduitReseauNumerique',
    type: Boolean,
    traduction: 'paramInterne.produit.ReseauNumerique',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  moduleProduitReseauTempo: {
    key: 'ModuleReseauTempo',
    type: Boolean,
    traduction: 'paramInterne.produit.reseauTempo',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  moduleProduitFaceUnitaire: {
    key: 'ModuleFaceUnitaire',
    type: Boolean,
    traduction: 'paramInterne.produit.faceUnitaire',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  moduleProduitReseauLc: {
    key: 'ModuleReseauLc',
    type: Boolean,
    traduction: 'paramInterne.produit.reseauLc',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  campagne: {
    key: 'Campagne',
    type: Boolean,
    traduction: 'paramInterne.campagne',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleRegroupementProduit: {
    key: 'ModuleRegroupementProduit',
    type: Boolean,
    traduction: 'paramInterne.moduleRegroupementProduit',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  demandeImpression: {
    key: 'DemandeImpression',
    type: Boolean,
    traduction: 'paramInterne.demandeImpression',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleSecteur: {
    key: 'ModuleSecteur',
    type: Boolean,
    traduction: 'paramInterne.moduleSecteur',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  filtreAgenceLogistiqueAffiche: {
    key: 'FiltreAgenceLogistiqueAffiche',
    type: Boolean,
    traduction: 'paramInterne.filtreAgence',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  contactsVenteSuperieur: {
    key: 'ContactsVenteSuperieur',
    type: Boolean,
    traduction: 'paramInterne.contactsVenteSuperieur',
    localisation: LOCALISATION_CONFIGURATION,
  },
  moduleEcranNumerique: {
    key: 'ModuleEcranNumerique',
    type: Boolean,
    traduction: 'paramInterne.moduleEcranNumerique',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  champObligatoireFacture: {
    key: 'ChampObligatoireFacture',
    type: Boolean,
    traduction: 'paramInterne.champObligatoireFacture',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  moduleLogistiqueImpression: {
    key: 'ModuleLogistiqueImpression',
    type: Boolean,
    traduction: 'paramInterne.moduleLogistiqueImpression',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleAchat: {
    key: 'ModuleAchat',
    type: Boolean,
    traduction: 'paramInterne.moduleAchat',
    localisation: LOCALISATION_ADMIN,
    modele: 'module',
  },
  moduleImpressionAffiche: {
    key: 'ModuleImpressionAffiche',
    type: Boolean,
    traduction: 'paramInterne.produit.impressionAffiche',
    localisation: LOCALISATION_ADMIN,
    modele: 'produit',
  },
  titreCommandeOrdrePublicite: {
    key: 'TitreCommandeOrdrePublicite',
    type: Boolean,
    traduction: 'paramInterne.titreCommandeOrdrePublicite',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  commissionHorsMarche: {
    key: 'CommissionHorsMarche',
    type: Boolean,
    traduction: 'paramInterne.commissionHorsMarche',
    localisation: LOCALISATION_ADMIN,
    modele: 'fonction',
  },
  // ICI les modeles SPE triés par ordre alphabétique sur les clients
  achatAASpe: {
    key: 'AchatAASpe',
    type: Boolean,
    traduction: 'paramInterne.achatAASpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  echeancesAFacturerAA: {
    key: 'EcheancesAFacturerAA',
    type: Boolean,
    traduction: 'paramInterne.echeancesAFacturerAA',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  echeancesAFacturerNegativesAA: {
    key: 'EcheancesAFacturerNegativesAA',
    type: Boolean,
    traduction: 'paramInterne.echeancesAFacturerNegativesAA',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  exportAloesredSpe: {
    key: 'ExportAloesredSpe',
    type: Boolean,
    traduction: 'paramInterne.exportAloesredSpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  diaporamaCBA: {
    key: 'CBADiaporama',
    type: Boolean,
    traduction: 'paramInterne.cbaDiaporama',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  previsionnelDepartCBA: {
    key: 'CBAPrevisionnelDepart',
    type: Boolean,
    traduction: 'paramInterne.CBAprevisionnelDepart',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  dimensionExportDcfCbaSpe: {
    key: 'DimensionExportDcfCbaSpe',
    type: Boolean,
    traduction: 'paramInterne.DimensionExportDcfCbaSpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  rendreObligatoireAssistantEtCommercialSurCommandeFacture: {
    key: 'RendreObligatoireAssistantEtCommercialSurCommandeFacture',
    type: Boolean,
    traduction: 'paramInterne.rendreObligatoireAssistantEtCommercialSurCommandeFacture',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  interdireModificationBlocageCLG: {
    key: 'InterdireModificationBlocageCLG',
    type: Boolean,
    traduction: 'paramInterne.interdireModificationBlocageCLG',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  editionSpeFicheFace: {
    key: 'EditionSpeFicheFace',
    type: Boolean,
    traduction: 'paramInterne.editionSpeFicheFace',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  futurisEditionSpeReseauTempo: {
    key: 'FuturisEditionSpeReseauTempo',
    type: Boolean,
    traduction: 'paramInterne.futurisEditionSpeReseauTempo',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  demandeAvoirBailleurGirodMediasSpe: {
    key: 'DemandeAvoirBailleurGirodMediasSpe',
    type: Boolean,
    traduction: 'paramInterne.demandeAvoirBailleurGirodMediasSpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  HSPParutionExport: {
    key: 'HSPParutionExport',
    type: Boolean,
    traduction: 'paramInterne.HSPParutionExport',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  factureClientHupmedia: {
    key: 'FactureClientHupmedia',
    type: Boolean,
    traduction: 'paramInterne.factureClientHupmedia',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  marqueObligatoirePointDeVenteSpe: {
    key: 'MarqueObligatoirePointDeVenteSpe',
    type: Boolean,
    traduction: 'paramInterne.marqueObligatoirePointDeVenteSpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  ligneCommandeARenouvelerSpe: {
    key: 'LigneCommandeARenouvelerSpe',
    type: Boolean,
    traduction: 'paramInterne.ligneCommandeARenouvelerSpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  importCommandeIdelia: {
    key: 'ImportCommandeIdelia',
    type: Boolean,
    traduction: 'paramInterne.importCommandeIdelia',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  exportLvc: {
    key: 'ExportLvc',
    type: Boolean,
    traduction: 'paramInterne.exportLvc',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  relevePubLvcSpe: {
    key: 'RelevePubLvcSpe',
    type: Boolean,
    traduction: 'paramInterne.relevePubLvcSpe',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  medialinePlanningLCRenouvellement: {
    key: 'MedialinePlanningLCRenouvellement',
    type: Boolean,
    traduction: 'paramInterne.MedialinePlanningLCRenouvellement',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
  editionPlanningReseauxTemposRegieMedia: {
    key: 'EditionPlanningReseauxTemposRegieMedia',
    type: Boolean,
    traduction: 'paramInterne.editionPlanningReseauxTemposRegieMedia',
    localisation: LOCALISATION_ADMIN,
    modele: 'specifique',
  },
};
